import { Typography, LinkButton } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import { formatDollar, formatTitleForMobile } from './utils'

export const OptionCardContent = ({
  icon,
  title,
  badgeText,
  resultMonths = 0,
  resultMonthsText,
  resultTotal = 0,
  resultTotalText,
  resultMonthly = 0,
  resultMonthlyText,
  disclaimer,
  pos,
  cta1,
  cta2,
  active,
  unavailableText,
}) => (
  <div
    className="lg:p-6 p-3 flex flex-col items-center text-center grow"
    data-testid="DebtPayoffCalculator-option-card-wrapper"
  >
    <div className={`${!active && 'opacity-50'} min-h-[60px]`}>{icon && icon}</div>

    <Typography
      component="h2"
      className="text-nowrap text-[#1D252F] mb-0 lg:mb-2 font-bold text-[16px] lg:font-medium lg:text-[20px] pb-3 lg:pb-4 leading-[1.2] tracking-normal text-center line-clamp-2 lg:whitespace-normal"
      content={formatTitleForMobile(title)}
      data-testid="DebtPayoffCalculator-option-card-title"
    />

    {active ? (
      <>
        <span
          className="text-nowrap bg-[#ECF9F4] text-[#048155] text-xs rounded-full font-normal p-3"
          data-testid="DebtPayoffCalculator-option-card-badge"
        >
          {badgeText}
        </span>

        <div className="my-6 space-y-4 w-full" data-testid="DebtPayoffCalculator-option-card-info">
          <div>
            <Typography
              component="span"
              className="lg:text-xl text-base font-medium text-[#1D252F] flex"
              content={`$${formatDollar(resultMonthly)}/mo`}
            />
            <Typography
              className="text-xs lg:text-[14px] font-normal lg:font-medium text-[#42546B] flex p-1 text-left"
              content={resultMonthlyText || 'Est. monthly payment⁵'}
            />
          </div>
          <div>
            <Typography
              component="span"
              className="lg:text-xl text-base font-medium text-[#1D252F] flex"
              content={`$${formatDollar(resultTotal)}`}
            />
            <Typography
              className="text-xs lg:text-[14px] font-normal lg:font-medium text-[#42546B] flex p-1 text-left"
              content={resultTotalText || 'Est. total debt to pay off⁶'}
            />
          </div>
          <div>
            <Typography
              component="span"
              className="lg:text-xl text-base font-medium text-[#1D252F] flex"
              content={`${resultMonths} months`}
            />
            <Typography
              className="text-xs lg:text-[14px] font-normal lg:font-medium text-[#42546B] flex p-1 text-left"
              content={resultMonthsText || 'Est. time to pay off debt⁷'}
            />
          </div>
        </div>

        <div
          className="mt-auto w-full space-y-3"
          data-testid="DebtPayoffCalculator-option-card-ctas"
        >
          {cta1?.link && cta1?.text && (
            <LinkButton
              className="text-[13px] p-[6px] lg:p-[8px_24px] min-h-2  lg:text-[14px] [&_p]:text-[13px] lg:[&_p]:text-[14px]"
              track={{
                ...{
                  click_position: pos >= 0 ? pos + 1 : '0',
                  click_id: cta1?.text,
                  click_text: cta1?.text,
                  track_event: 'internal_campaign_click',
                  event_action: 'button_click',
                  event_type: 'button_click',
                },
                ...cta1?.track,
              }}
              content={{ linkText: cta1?.text, linkHref: cta1?.link }}
              typographicOptions={{
                variantOverride: { [BLOCKS.PARAGRAPH]: 'bodyLg' },
                fontWeight: 'bold',
              }}
              color="primary"
              variant={LinkButton.VARIANTS.CONTAINED}
              fullWidth={true}
            />
          )}
          {cta2?.link && cta2?.text && (
            <LinkButton
              className="text-[13px] p-[6px] lg:p-[8px_24px] min-h-2  lg:text-[14px] mt-4 [&_p]:text-[13px] lg:[&_p]:text-[14px]"
              track={{
                ...{
                  click_position: pos >= 0 ? pos + 1 : '0',
                  click_id: cta2?.text,
                  click_text: cta2?.text,
                  nav_link_section: 'Product Cards',
                  track_event: 'internal_campaign_click',
                  event_action: 'button_click',
                  event_type: 'button_click',
                },
                ...cta2?.track,
              }}
              content={{ linkText: cta2?.text, linkHref: cta2?.link }}
              typographicOptions={{
                variantOverride: { [BLOCKS.PARAGRAPH]: 'bodyLg' },
                fontWeight: 'bold',
              }}
              color="secondary"
              variant={LinkButton.VARIANTS.CONTAINED}
              fullWidth={true}
            />
          )}
        </div>
        {disclaimer && (
          <Typography
            className="text-xs lg:text-[14px] font-normal lg:font-medium text-[#42546B] mt-4 max-w-[120px] text-center sm:max-w-none sm:text-left"
            content={disclaimer}
          />
        )}
      </>
    ) : (
      <>
        <span className="text-nowrap bg-[#EFF5FF] text-[#42546B] text-xs rounded-full font-normal p-3">
          Unavailable
        </span>
        <Typography className="text-xs mt-4 text-[#42546B] text-left" content={unavailableText} />
      </>
    )}
  </div>
)
